import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=125ae627&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=ts"
export * from "./TabNavigation.vue?vue&type=script&lang=ts"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=125ae627&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ae627",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('125ae627')) {
      api.createRecord('125ae627', component.options)
    } else {
      api.reload('125ae627', component.options)
    }
    module.hot.accept("./TabNavigation.vue?vue&type=template&id=125ae627&scoped=true", function () {
      api.rerender('125ae627', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/TabNavigation.vue"
export default component.exports